<template>
    <section class="rich-text">
        <span v-if="banner.length">
            <img
                v-for="(item, index) in banner"
                v-lazy="
                    item.resourceKey.url && handleImg({ url: item.resourceKey.url, width: 750 })
                "
                :key="index"
                alt=""
            />
        </span>
        <div v-if="desc" class="ql-container ql-snow">
            <div
                id="goods-detail"
                class="goods-detail ql-editor"
                v-html="desc"
                v-lazy-container="{ selector: 'img' }"
            ></div>
        </div>
        <div v-if="shoppingInstructions" class="shopping-instructions">
            <img
                v-for="(item, index) in shoppingInstructions"
                v-lazy="
                    item.resourceKey.url && handleImg({ url: item.resourceKey.url, width: 750 })
                "
                :key="index"
                alt=""
            />
        </div>
    </section>
</template>
<script>
import '@/assets/css/quill.snow.css'
export const GoodsBannerType = 2
export const GoodsNeedType = [4, 5, 6, 7]
export default {
    props: {
        description: String,
        merchandiseResources: Array
    },
    data() {
        return {
            desc: '',
            lang: navigator.language.includes('zh')
        }
    },
    computed: {
        banner() {
            // 轮播图
            return (this.merchandiseResources || [])
                .filter((item) => item.resourceBizType === GoodsBannerType)
                .sort((a, b) => a.sort - b.sort)
            // .slice(0, 1)
        },
        shoppingInstructions() {
            // 模板样式
            return (this.merchandiseResources || [])
                .filter((item) => GoodsNeedType.includes(item.resourceBizType))
                .sort((a, b) => a.sort - b.sort)
        }
    },
    watch: {
        description: {
            handler: function (val) {
                if (val) {
                    this.desc = this.description.replace(
                        /<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
                        (match, url) => {
                            const names = match.replace(/src/g, 'data-src')
                            const newurl = this.handleImg({ url, width: 750 })
                            return names.replace(/"(.*?)"/g, newurl)
                        }
                    )
                }
            },
            immediate: true
        }
    }
}
</script>
<style lang="less" scoped>
img {
    display: block;
}
.rich-text {
    h2 {
        padding: 12px;
        font-size: 16px;
        line-height: 22px;
        color: #161a1a;
        background-color: #fff;
    }
    img {
        width: 100%;
    }
}
.goods-detail {
    padding: 0 15px;
    text-align: left;
    display: block;
    font-size: 15px;
    color: #777;
    overflow-x: hidden;
    background: #fff;
    font-weight: none;
    /deep/ img,
    /deep/ video {
        display: block;
        width: 100%;
    }
    /deep/ em {
        font-style: italic;
    }
    /deep/ strong {
        font-weight: bold;
    }
    /deep/ h3 {
        margin: 12px 0;
        text-align: center;
    }
    /deep/ p {
        padding: 0;
        margin: 5px 0;
        display: block;
    }
    /deep/ * {
        max-width: 100%;
    }
    /deep/ iframe,
    video,
    embed {
        width: 100% !important;
        height: 200px !important;
        border: 0;
    }
    /deep/ &.guide {
        margin: 10px 0;
        h3 {
            font-size: 14px;
            color: black;
            padding-bottom: 10px;
            text-align: center;
        }
    }
}
.shopping-instructions {
    margin-top: 12px;
}
</style>
